import { intl } from '../../platform/localization'

export const messages = {
  get textNotifyMarkPersonAsSuccess() {
    return intl.formatMessage({
      defaultMessage: 'Success',
      description: 'Text notify mark person as success',
    })
  },
}
